import React from 'react';

export const WarningIcon = () => {

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24.999" viewBox="0 0 25 24.999">
            <path id="alert-diamond" d="M24.782,11.389,14.44,1.046a2.158,2.158,0,0,0-3.051,0L1.046,11.39a2.158,2.158,0,0,0,0,3.051h0L11.389,24.782a2.158,2.158,0,0,0,3.051,0L24.782,14.441A2.158,2.158,0,0,0,24.782,11.389Zm-12.873-4.5a1.079,1.079,0,1,1,2.158,0v6.473a1.079,1.079,0,1,1-2.158,0Zm1.134,12.418h-.03a1.65,1.65,0,0,1-1.642-1.586,1.591,1.591,0,0,1,1.562-1.651h.03A1.647,1.647,0,0,1,14.6,17.658a1.591,1.591,0,0,1-1.562,1.651Z" transform="translate(-0.414 -0.414)" />
        </svg>
    )
}